import script from "./SignInComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignInComponent.vue?vue&type=style&index=0&id=b91bc54e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91bc54e"]])

export default __exports__